import React, { useState, useEffect } from 'react';
import {
  Container,
  Button,
  Form,
  Row,
  Col,
  Tabs,
  Tab,
  Badge,
  Modal,
} from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FaEdit, FaTrash, FaSave, FaTimes, FaArrowLeft, FaFileImport, FaUsers } from 'react-icons/fa';
import Loading from '~/Components/Loading';
import history from '~/Config/history';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import CardRazoesSociais from './components/CardRazoesSociais';
import CardGruposGE from './components/CardGruposGE';
import TabGeral from './components/TabGeral';
import TabApuracaoResultados from './components/TabApuracaoResultados';
import TabJurosTaxas from './components/TabJurosTaxas';
import TabImoveis from './components/TabImoveis';
import TabPropostaTitulos from './components/TabPropostaTitulos';
import TabFaixasContas from './components/TabFaixasContas';
import ModalImportContas from './components/ModalImportContas';
import ModalImportParam from './components/ModalImportParam';
import { menuPortalProps, mergeSelectStyles } from './components/selectMenuPortal';
import './styles.css';

var GrupoEmpresaDetalhes = function (_ref) {
  var match = _ref.match;
  var codigo = match && match.params && match.params.codigo;

  var temPermissaoStatus = AuthStorage.temCaracteristicas([caracteristicas.AlteraStatusGE]) ||
    AuthStorage.temCaracteristicas([caracteristicas.AlteraStatusGE2]);

  var [detalhe, setDetalhe] = useState(null);
  var [parametros, setParametros] = useState(null);
  var [categorias, setCategorias] = useState([]);
  var [gesLookup, setGesLookup] = useState([]);
  var [loading, setLoading] = useState(true);
  var [editando, setEditando] = useState(false);
  var [loadingAcao, setLoadingAcao] = useState(false);
  var [loadingSalvarParam, setLoadingSalvarParam] = useState(false);

  // Form do cabeçalho
  var [formHeader, setFormHeader] = useState({ categoria: null, status: '', apelido: '' });

  // Modais
  var [showConfirmExcluir, setShowConfirmExcluir] = useState(false);
  var [showConfirmUsuarios, setShowConfirmUsuarios] = useState(false);
  var [showModalImportContas, setShowModalImportContas] = useState(false);
  var [showModalImportParam, setShowModalImportParam] = useState(false);

  // Parâmetros (estado editável)
  var [parametrosEdit, setParametrosEdit] = useState(null);

  // Accordion — múltiplas seções podem estar abertas simultaneamente
  var [openSections, setOpenSections] = useState({ parametros: true });

  var toggleSection = function (key) {
    setOpenSections(function (prev) {
      var next = {};
      for (var k in prev) { next[k] = prev[k]; }
      next[key] = !prev[key];
      return next;
    });
  };

  useEffect(function () {
    carregarTudo();
    carregarGesLookup();
  }, [codigo]);

  var carregarTudo = async function () {
    setLoading(true);
    try {
      var [resDetalhe, resCat] = await Promise.all([
        api.obterDetalhesGrupoEmpresa(codigo),
        api.listarCategoriasGE(),
      ]);
      setDetalhe(resDetalhe);
      setCategorias((resCat || []).map(function (c) { return { value: c.codigo, label: c.descricao }; }));
      var catOpt = (resCat || []).find(function (c) { return c.codigo === (resDetalhe && resDetalhe.header && resDetalhe.header.categoria); });
      setFormHeader({
        categoria: catOpt ? { value: catOpt.codigo, label: catOpt.descricao } : null,
        status: (resDetalhe && resDetalhe.header && resDetalhe.header.status) || '',
        apelido: (resDetalhe && resDetalhe.header && resDetalhe.header.apelido) || '',
      });
      await carregarParametros();
    } catch (e) {
      toast.error('Erro ao carregar dados do GE');
    } finally {
      setLoading(false);
    }
  };

  var carregarParametros = async function () {
    try {
      var res = await api.obterParametrosGrupoEmpresa(codigo);
      setParametros(res);
      setParametrosEdit(res);
    } catch (e) {
      // sem parâmetros ainda
    }
  };

  var carregarGesLookup = async function () {
    try {
      var res = await api.listarGruposEmpresaAdmin({});
      setGesLookup(res || []);
    } catch (e) {
      // silencioso
    }
  };

  var recarregarDetalhe = async function () {
    try {
      var res = await api.obterDetalhesGrupoEmpresa(codigo);
      setDetalhe(res);
    } catch (e) {
      toast.error('Erro ao recarregar dados');
    }
  };

  var handleEditar = function () {
    if (detalhe && detalhe.header) {
      var catOpt = categorias.find(function (c) { return c.value === detalhe.header.categoria; });
      setFormHeader({
        categoria: catOpt || null,
        status: detalhe.header.status || '',
        apelido: detalhe.header.apelido || '',
      });
    }
    setEditando(true);
  };

  var handleCancelar = function () {
    setEditando(false);
  };

  var handleSalvarHeader = async function () {
    setLoadingAcao(true);
    try {
      await api.atualizarGrupoEmpresa(codigo, {
        categoria: formHeader.categoria ? formHeader.categoria.value : null,
        status: formHeader.status,
        apelido: formHeader.apelido,
      });
      toast.success('Dados do GE atualizados!');
      setEditando(false);
      await recarregarDetalhe();
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao salvar';
      toast.error(msg);
    } finally {
      setLoadingAcao(false);
    }
  };

  var handleExcluir = async function () {
    setLoadingAcao(true);
    try {
      await api.excluirGrupoEmpresa(codigo);
      toast.success('Grupo de Empresa excluído!');
      history.push('/ferramentas/grupo-empresa');
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao excluir';
      toast.error(msg);
      setShowConfirmExcluir(false);
    } finally {
      setLoadingAcao(false);
    }
  };

  var handleSalvarParametros = async function () {
    setLoadingSalvarParam(true);
    try {
      await api.salvarParametrosGrupoEmpresa(codigo, parametrosEdit);
      toast.success('Parâmetros salvos com sucesso!');
      await carregarParametros();
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao salvar parâmetros';
      toast.error(msg);
    } finally {
      setLoadingSalvarParam(false);
    }
  };

  var handleIncluirUsuariosAtivos = async function () {
    setLoadingAcao(true);
    try {
      await api.incluirGEUsuariosAtivos(codigo);
      toast.success('GE incluído nos usuários ativos com sucesso!');
      setShowConfirmUsuarios(false);
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao incluir usuários';
      toast.error(msg);
    } finally {
      setLoadingAcao(false);
    }
  };

  if (loading) return <Loading />;

  var header = (detalhe && detalhe.header) || {};
  var razoesSociais = (detalhe && detalhe.razoes_sociais) || [];
  var gruposGE = (detalhe && detalhe.grupos_ge) || [];
  var gestaoOP = (detalhe && detalhe.gestao_op) || [];

  var badgeStatus = function (status) {
    if (status === 'A') return <Badge variant="success">Ativo</Badge>;
    if (status === 'I') return <Badge variant="secondary">Inativo</Badge>;
    if (status === 'C') return <Badge variant="warning">Consulta</Badge>;
    return <Badge variant="light">{status}</Badge>;
  };

  var statusOptions = [
    { value: 'A', label: 'Ativo' },
    { value: 'I', label: 'Inativo' },
    { value: 'C', label: 'Consulta' },
  ];

  // Helper: renderiza header de seção accordion
  var renderAccordionHeader = function (key, title, badge, extraRight) {
    var isOpen = !!openSections[key];
    return (
      <div
        className={'ge-accordion-header' + (isOpen ? ' active' : '')}
        onClick={function () { toggleSection(key); }}
      >
        <div className="ge-accordion-header-left">
          <span className="ge-accordion-title">{title}</span>
          {badge !== undefined && badge !== null && (
            <span className="ge-accordion-badge">{badge}</span>
          )}
        </div>
        <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
          {extraRight}
          <span className={'ge-accordion-icon' + (isOpen ? ' expanded' : '')}>&#9660;</span>
        </div>
      </div>
    );
  };

  return (
    <Container fluid className="px-3 py-3">

      {/* === Sticky Header === */}
      <div className="ge-sticky-header">
        <div className="ge-sticky-header-inner">
          <div className="ge-sticky-header-left">
            <a className="ge-sticky-header-back" onClick={function () { history.push('/ferramentas/grupo-empresa'); }}>
              <FaArrowLeft size={12} /> Voltar
            </a>
            <span className="ge-sticky-header-divider" />
            <h1 className="ge-sticky-header-title">Grupo Empresa #{header.codigo || codigo}</h1>
            <span className="ge-sticky-header-code">{header.apelido || 'Sem apelido'}</span>
            {badgeStatus(header.status)}
          </div>
          <div className="ge-sticky-header-actions">
            <Button size="sm" variant="outline-secondary" onClick={function () { setShowModalImportContas(true); }}>
              <FaFileImport className="mr-1" /> Import Contas GEs
            </Button>
            <Button size="sm" variant="outline-secondary" onClick={function () { setShowConfirmUsuarios(true); }}>
              <FaUsers className="mr-1" /> Inclui GE Usuários Ativos
            </Button>
          </div>
        </div>
      </div>

      {/* === Seção fixa: Dados do GE === */}
      <div className="ge-dados-section">
        <div className="ge-dados-header">
          <strong>Dados do GE</strong>
          <div className="ge-dados-actions">
            {!editando ? (
              <>
                <Button size="sm" variant="outline-primary" onClick={handleEditar}>
                  <FaEdit className="mr-1" /> Editar
                </Button>
                <Button size="sm" variant="outline-danger" onClick={function () { setShowConfirmExcluir(true); }}>
                  <FaTrash className="mr-1" /> Excluir
                </Button>
              </>
            ) : (
              <>
                <Button size="sm" variant="success" onClick={handleSalvarHeader} disabled={loadingAcao}
                  style={{ backgroundColor: '#7bb32e', borderColor: '#7bb32e' }}>
                  <FaSave className="mr-1" /> {loadingAcao ? 'Salvando...' : 'Salvar'}
                </Button>
                <Button size="sm" variant="secondary" onClick={handleCancelar} disabled={loadingAcao}>
                  <FaTimes className="mr-1" /> Cancelar
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="ge-dados-body">
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small mb-1">Código</Form.Label>
                <Form.Control size="sm" type="text" readOnly value={header.codigo || codigo} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small mb-1">Categoria</Form.Label>
                <Select
                  value={editando ? formHeader.categoria : (categorias.find(function (c) { return c.value === header.categoria; }) || null)}
                  options={categorias}
                  onChange={function (opt) { setFormHeader(function (prev) { return Object.assign({}, prev, { categoria: opt }); }); }}
                  isDisabled={!editando}
                  placeholder="Selecione..."
                  {...menuPortalProps}
                  styles={mergeSelectStyles({ control: function (base) { return Object.assign({}, base, { minHeight: 31, fontSize: '0.875rem' }); } })}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small mb-1">Status</Form.Label>
                {editando && temPermissaoStatus ? (
                  <Form.Control
                    size="sm"
                    as="select"
                    value={formHeader.status}
                    onChange={function (e) { var val = e.target.value; setFormHeader(function (prev) { return Object.assign({}, prev, { status: val }); }); }}
                  >
                    {statusOptions.map(function (s) { return <option key={s.value} value={s.value}>{s.label}</option>; })}
                  </Form.Control>
                ) : (
                  <div className="mt-1">{badgeStatus(editando ? formHeader.status : header.status)}</div>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small mb-1">Apelido</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  maxLength={30}
                  readOnly={!editando}
                  value={editando ? formHeader.apelido : (header.apelido || '')}
                  onChange={function (e) { var val = e.target.value; setFormHeader(function (prev) { return Object.assign({}, prev, { apelido: val }); }); }}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>

      {/* === Accordion === */}
      <div className="ge-accordion">

        {/* --- Seção: Razões Sociais --- */}
        <div className="ge-accordion-section">
          {renderAccordionHeader('razoes', 'Razões Sociais', razoesSociais.length)}
          <div className={'ge-accordion-content' + (openSections.razoes ? ' show' : '')}>
            <div className="ge-accordion-body">
              <CardRazoesSociais
                codigoGE={Number(codigo)}
                razoesSociais={razoesSociais}
                onReload={recarregarDetalhe}
                embedded
              />
            </div>
          </div>
        </div>

        {/* --- Seção: Grupos de GE --- */}
        <div className="ge-accordion-section">
          {renderAccordionHeader('grupos', 'Grupos de GE', gruposGE.length)}
          <div className={'ge-accordion-content' + (openSections.grupos ? ' show' : '')}>
            <div className="ge-accordion-body">
              <CardGruposGE
                codigoGE={Number(codigo)}
                gruposGE={gruposGE}
                onReload={recarregarDetalhe}
                embedded
              />
            </div>
          </div>
        </div>

        {/* --- Seção: Parâmetros (principal — expandida por default) --- */}
        <div className="ge-accordion-section">
          {renderAccordionHeader('parametros', 'Parâmetros', '6 abas')}
          <div className={'ge-accordion-content' + (openSections.parametros ? ' show' : '')}>
            <div className="ge-accordion-body ge-params-tabs">
              <Tabs defaultActiveKey="geral" className="mb-3">
                <Tab eventKey="geral" title="Geral">
                  <TabGeral parametros={parametrosEdit} onChange={setParametrosEdit} />
                </Tab>
                <Tab eventKey="apuracao" title="Apuração de Resultados">
                  <TabApuracaoResultados
                    parametros={parametrosEdit}
                    onChange={setParametrosEdit}
                    codigoGE={Number(codigo)}
                    gestaoOP={gestaoOP}
                    onReloadGestaoOP={recarregarDetalhe}
                    gesLookup={gesLookup}
                  />
                </Tab>
                <Tab eventKey="juros" title="Juros/Taxas">
                  <TabJurosTaxas parametros={parametrosEdit} onChange={setParametrosEdit} />
                </Tab>
                <Tab eventKey="imoveis" title="Imóveis">
                  <TabImoveis parametros={parametrosEdit} onChange={setParametrosEdit} gesLookup={gesLookup} />
                </Tab>
                <Tab eventKey="proposta" title="Proposta/Títulos">
                  <TabPropostaTitulos parametros={parametrosEdit} onChange={setParametrosEdit} />
                </Tab>
                <Tab eventKey="faixas" title="Faixas de Contas">
                  <TabFaixasContas parametros={parametrosEdit} onChange={setParametrosEdit} />
                </Tab>
              </Tabs>
              <div className="text-right mt-2">
                <Button variant="outline-secondary" size="sm" className="mr-2" onClick={function () { setShowModalImportParam(true); }}>
                  <FaFileImport className="mr-1" /> Import Param GE
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={handleSalvarParametros}
                  disabled={loadingSalvarParam}
                  style={{ backgroundColor: '#7bb32e', borderColor: '#7bb32e' }}
                >
                  <FaSave className="mr-1" /> {loadingSalvarParam ? 'Salvando...' : 'Salvar Parâmetros'}
                </Button>
              </div>
            </div>
          </div>
        </div>

      </div>{/* fim ge-accordion */}

      {/* Modal: Confirmar Exclusão */}
      <Modal show={showConfirmExcluir} onHide={function () { setShowConfirmExcluir(false); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Grupo de Empresa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja excluir o GE <strong>{header.apelido || codigo}</strong>?
          <br />
          <small className="text-danger">
            Esta ação é irreversível e removerá todos os registros relacionados (parâmetros, contas, etc.).
            Só é possível excluir se não houver razões sociais vinculadas.
          </small>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function () { setShowConfirmExcluir(false); }}>Cancelar</Button>
          <Button variant="danger" onClick={handleExcluir} disabled={loadingAcao}>
            {loadingAcao ? 'Excluindo...' : 'Excluir'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal: Confirmar Incluir Usuários Ativos */}
      <Modal show={showConfirmUsuarios} onHide={function () { setShowConfirmUsuarios(false); }} centered size="sm">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1rem' }}>Incluir GE Usuários Ativos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Isso adicionará este GE (<strong>{header.apelido || codigo}</strong>) a <strong>todos</strong> os usuários ativos. Deseja continuar?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={function () { setShowConfirmUsuarios(false); }}>Cancelar</Button>
          <Button variant="primary" size="sm" onClick={handleIncluirUsuariosAtivos} disabled={loadingAcao}
            style={{ backgroundColor: '#7bb32e', borderColor: '#7bb32e' }}>
            {loadingAcao ? 'Processando...' : 'Confirmar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Import Contas */}
      <ModalImportContas
        show={showModalImportContas}
        onHide={function () { setShowModalImportContas(false); }}
        codigoGE={Number(codigo)}
        gesLookup={gesLookup}
      />

      {/* Modal Import Param */}
      <ModalImportParam
        show={showModalImportParam}
        onHide={function () { setShowModalImportParam(false); }}
        codigoGE={Number(codigo)}
        gesLookup={gesLookup}
        temParametros={!!(parametros && parametros.cod_param)}
        onImportado={carregarParametros}
      />
    </Container>
  );
};

export default GrupoEmpresaDetalhes;
